/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// tslint:disable:variable-name

import { ID } from '@gh/common-shared-data';
import { entity } from '@gh/core-data';

export type UomSharedListItemDto = {
  id: ID;
  code: string;
  name: string;
};

export const UomSharedListItemMapper = entity<UomSharedListItemDto>();
